import { render, staticRenderFns } from "./duo_chat_callout.vue?vue&type=template&id=52fa6be6"
import script from "./duo_chat_callout.vue?vue&type=script&lang=js"
export * from "./duo_chat_callout.vue?vue&type=script&lang=js"
import style0 from "./duo_chat_callout.vue?vue&type=style&index=0&id=52fa6be6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports